function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var l = function l(e, r, t) {
  return new Promise(function (n, i) {
    var d = function d(o) {
      try {
        c(t.next(o));
      } catch (a) {
        i(a);
      }
    },
        m = function m(o) {
      try {
        c(t.throw(o));
      } catch (a) {
        i(a);
      }
    },
        c = function c(o) {
      return o.done ? n(o.value) : Promise.resolve(o.value).then(d, m);
    };

    c((t = t.apply(e, r)).next());
  });
};

function f(e) {
  return document.querySelector("script[src=\"".concat(e, "\"]"));
}

function S(e) {
  var r = document.head || document.body;
  if (!r) throw new Error("Square.js requires a <body> or <head> element.");
  var t = document.createElement("script");
  return t.src = e, r.appendChild(t), t;
}

var s = null;

function p(e) {
  return s !== null || (s = new Promise(function (r, t) {
    if (typeof window == "undefined") {
      r(null);
      return;
    }

    if (window.Square) {
      r(window.Square);
      return;
    }

    try {
      var n = f(e);
      n || (n = S(e)), n.addEventListener("load", function () {
        window.Square ? r(window.Square) : t(new Error("Square.js failed to load properly."));
      }), n.addEventListener("error", function () {
        t(new Error("Error occurred while loading Square.js"));
      });
    } catch (n) {
      t(n);
    }
  })), s;
}

var w = "v1",
    u = /*#__PURE__*/function (_Error) {
  _inherits(u, _Error);

  var _super = _createSuper(u);

  function u() {
    var _this;

    var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "The Payment 'applicationId' option is not in the correct format.";

    _classCallCheck(this, u);

    _this = _super.call(this, r);
    _this.name = "InvalidApplicationIdError", Object.setPrototypeOf(_assertThisInitialized(_this), u.prototype);
    return _this;
  }

  return _createClass(u);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function q(e) {
  var r = "";
  if (e.startsWith("sq0idp-") && (r = "https://web.squarecdn.com/"), e.startsWith("sandbox-sq0idb-") && (r = "https://sandbox.web.squarecdn.com/"), r.length === 0) throw new u();
  return r += "".concat(w, "/square.js"), r;
}

function E(e, r, t) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var n, i;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            n = (t == null ? void 0 : t.scriptSrc) !== void 0 ? t.scriptSrc : q(e);
            _context.next = 3;
            return p(n);

          case 3:
            i = _context.sent;
            return _context.abrupt("return", i === null ? null : i.payments(e, r));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

export { E as payments };